export const traducciones = {
    es: {
      title: "Hola,",
      subtitle: "Somos QANTICO DEVS",
      description: "Donde las ideas se convierten en soluciones",
      message: "Creamos software y páginas web a medida para impulsar tu negocio. No importa si no eres experto en tecnología: nosotros nos encargamos de todo. Desde diseños atractivos hasta funcionalidades poderosas, hacemos que tu presencia digital sea sencilla, efectiva y memorable.",
      subtitle2: "¿Listo para transformar tu visión en realidad?",
      message2: "Con QANTICO DEVS, el futuro es claro, simple y a un clic de distancia.",
      title2: "Trabajemos juntos",
      subtitle3: "En QANTICO DEVS",
      description2: "En QANTICO DEVS no solo desarrollamos software y páginas web, creamos herramientas que hacen crecer tu negocio. ¿Necesitas una web rápida y moderna? ¿Una aplicación que simplifique tus procesos? ¿O quizás algo único que nadie más ofrece?",
      message3: "Nos adaptamos a tus necesidades, sin complicaciones. Tú imagínalo, nosotros lo programamos.",
      subtitle4: "¿Por qué elegirnos?",
      list1: "Soluciones  eficientes a medida, creadas especialmente para ti.",
      list2: "Comprometidos con tu éxito.",
      list3: "Resultados que superan expectativas",
      button_contact: "Contáctanos hoy y empieza a transformar tus ideas en realidad.",
      // Añade aquí más traducciones para toda la aplicación
    },
    en: {
      title: "Hi,",
      subtitle: "We are QANTICO DEVS",      
      description: "Where ideas become solutions",
      message: "We create custom software and websites to boost your business. Whether you're not an expert in technology: we take care of everything. From attractive designs to powerful functionalities, we make your digital presence simple, effective, and memorable.",
      subtitle2: "Ready to transform your vision into reality?",
      message2: "With QANTICO DEVS, the future is clear, simple, and just a click away.",
      title2: "Let's work together",
      subtitle3: "In QANTICO DEVS",
      description2: "In QUANTICO DEVS, We don't just develop software and websites, we create tools that grow your business. Need a fast and modern website? An app that simplifies your processes? Or maybe something unique that no one else offers?",    
      message3: "We adapt to your needs, without complications. You imagine it, we program it.",
      subtitle4: "Why choose us?",
      list1: "Efficient, tailor-made solutions, created especially for you.",
      list2: "Committed to your success.",
      list3: "Results that exceed expectations",
      button_contact: "Contact us today and start transforming your ideas into reality.",
      // Añade aquí más traducciones para toda la aplicación
    }
  };